import { useState } from "react";
import { useAppSelector, useAppDispatch } from "../app/hooks";
import { useTranslation } from "react-i18next";
//FIXME: circular dependency prevents importing constants
import { selectGuides, deleteGuide } from "./patternSlice";
import { setHoverGuideIndex } from "./toolsSlice";
import { HANDLE_RADIUS } from "./canvas/constants";

export type GuideOld = [number, "hLine" | "vLine"];

export const GUIDE_HORIZONTAL = "h";
export const GUIDE_VERTICAL = "v";

export interface Guide {
  type: "h" | "v";
  originIndex: number | null;
  pos: number;
  length: number;
  lengthExpresion: number | string;
  direction: 1 | -1;
  label: string;
}

export interface GuidesProps {
  width: number;
  height: number;
  onMouseDown: Function;
}

export function Guides({ width, height, onMouseDown }: GuidesProps) {
  const { t } = useTranslation();
  const [active, setActive] = useState(-1);
  const [initialClick, setInitialClick] = useState({ x: 0, y: 0 });
  const [clickPoint, SetClickPoint] = useState({ x: 0, y: 0 });
  const dispatch = useAppDispatch();
  const guides = useAppSelector(selectGuides);

  return (
    <>
      {guides.map(({ pos, type }, i) => {
        let points = {};
        if (type === GUIDE_HORIZONTAL) {
          points = {
            x1: 0,
            x2: width,
            y1: pos,
            y2: pos,
          };
        } else {
          points = {
            x1: pos,
            x2: pos,
            y1: 0,
            y2: height,
          };
        }

        return (
          <g
            className="guide"
            onMouseDown={(e) => {
              onMouseDown(i);
              setInitialClick({ x: e.clientX, y: e.clientY });
            }}
            key={i}
            onClick={(e: React.MouseEvent<SVGElement>) => {
              const ele = e.currentTarget;
              const svg = ele.closest("svg");
              if (!svg) {
                return;
              }
              let pt = svg.createSVGPoint();
              pt.x = e.clientX;
              pt.y = e.clientY;
              const cursorpt = pt.matrixTransform(
                svg.getScreenCTM()!.inverse()
              );

              if (
                e.clientX === initialClick.x &&
                e.clientY === initialClick.y
              ) {
                setActive(active === i ? -1 : i);
                SetClickPoint({ x: cursorpt.x, y: cursorpt.y });
              } else {
                setActive(-1);
              }
            }}
            onMouseOver={() => {
              dispatch(setHoverGuideIndex(i));
            }}
            onMouseLeave={() => {
              dispatch(setHoverGuideIndex(-1));
            }}
          >
            <line {...points} className="hover" />
            <line {...points} />

            {active === i && (
              <g className="delete-button">
                <title>{t("delete guide")}</title>
                <circle
                  onClick={(e) => {
                    e.stopPropagation();
                    setActive(-1);
                    dispatch(deleteGuide(i));
                  }}
                  cx={clickPoint.x - HANDLE_RADIUS / 3}
                  cy={clickPoint.y + HANDLE_RADIUS / 3}
                  r={HANDLE_RADIUS}
                />
                <text x={clickPoint.x - 6} y={clickPoint.y + 6}>
                  X
                </text>
              </g>
            )}
          </g>
        );
      })}
    </>
  );
}
